import React from 'react'
import {
    BackButton,
    Bloc,
    BlocTextField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
    BlocPhoneNumber,
    Title,
} from '../ImportAll'

export default function Vue18() {
    return (
        <div>
            <Header
                title="Vous possédez deja un crédit ou une offre de banque ?"
                subTitle="Informations de contacts"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={100} time={1} />
            </div>

            <div className="Container">
                <BlocTextField
                    key="key146"
                    nbcolumn={1}
                    linked_data_id="contact_nom"
                    label="Nom"
                    placeholder="Votre nom"
                />
                <BlocTextField
                    key="key147"
                    nbcolumn={1}
                    linked_data_id="contact_prenom"
                    label="Prénom"
                    placeholder="Votre prénom"
                />
                <BlocPhoneNumber
                    key="key148"
                    nbcolumn={1}
                    linked_data_id="contact_mobile"
                    label="Numéro de téléphone"
                    placeholder="Votre numéro de téléphone mobile"
                    messageErreur="Numéro invalide"
                    infobulle="Votre numéro doit prendre en compte l'indicatif. Pour cela le premier chiffre '0' ne doit pas étre entré. Un numéro tel '01234567890' sera '+33 1234567890'"
                />
                <BlocTextField
                    key="key149"
                    nbcolumn={1}
                    linked_data_id="contact_mail"
                    label="E-mail de contact"
                    placeholder="Votre E-mail de contact"
                    checkedByRegex={
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    }
                    messageErreur="Adresse mail invalide"
                    removeEspace
                />
                {process.env.REACT_APP_CODE_PROMO === 'true' && (
                    <BlocTextField
                        key="key160"
                        nbcolumn={1}
                        linked_data_id="code_promo"
                        label="Avez-vous un code promotionnel ?"
                        placeholder="Code promotionnel"
                        removeEspace
                    />
                )}
                <Title maintitle="Nombre d'emprunteurs" />

                <Bloc
                    key="key42"
                    selectable
                    linked_data_id="emp_type_emprunteur"
                    linked_data_value="1"
                    nbcolumn={3}
                    gauche
                    imageTextStyle
                    logourl="svg/one_person.svg"
                    text1="Vous empruntez"
                    text2="Seul"
                />
                <Bloc
                    key="key43"
                    selectable
                    linked_data_id="emp_type_emprunteur"
                    linked_data_value="2"
                    nbcolumn={3}
                    milieu
                    imageTextStyle
                    logourl="svg/two_person.svg"
                    text1="Vous empruntez"
                    text2="À deux"
                />
                <Bloc
                    key="key44"
                    selectable
                    linked_data_id="emp_type_emprunteur"
                    linked_data_value="SCI"
                    nbcolumn={3}
                    droit
                    imageTextStyle
                    logourl="svg/scpi.svg"
                    text1="Vous empruntez"
                    text2="en SCI"
                />
            </div>

            <Conditionnal linked_data_id="contact_nom" isNotEmpty>
                <Conditionnal linked_data_id="contact_prenom" isNotEmpty>
                    <Conditionnal
                        linked_data_id="contact_mobile_validated"
                        isEqualTo
                        targetDataValueCompare={true}
                    >
                        <Conditionnal
                            linked_data_id="contact_mail_validated"
                            isEqualTo
                            targetDataValueCompare={true}
                        >
                            <Conditionnal
                                linked_data_id="emp_type_emprunteur"
                                isNotEmpty
                            >
                                <div className="SubmitButtonContainer">
                                    {' '}
                                    <Button
                                        text="Suivant"
                                        targetView={19}
                                    />{' '}
                                </div>
                            </Conditionnal>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
